import {
  ParagraphText,
  useMediaQuery,
  queryHelpers,
} from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import deleteAccountSuccess from "assets/success-check.svg";
import { ImageMessageModalContent } from "components/modals/common/image-message-modal-content.component";
import { PRODUCT_AREA } from "@leagueplatform/analytics";
import { ANALYTICS_SCREEN_NAMES, ANALYTICS_DETAILS } from "common/constants";
import { ModalActionButton } from "./common/modal-action-button.component";

export const AccountDeletedModal = () => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery(queryHelpers.only("mobile"));

  return (
    <ImageMessageModalContent
      image={deleteAccountSuccess}
      title={formatMessage({ id: "STR_ACCOUNT_DELETED_HEADING" })}
      titleLevel="3"
      footer={
        <ModalActionButton
          actionType="submit"
          buttonText={formatMessage({ id: "STR_I_UNDERSTAND" })}
          isMobile={isMobile}
          css={{
            backgroundColor: "$primaryBackgroundDefault",
            alignSelf: "flex-end",
            "&:hover": {
              backgroundColor: "$primaryBackgroundHovered",
            },
          }}
          trackAnalytics={{
            product_area: PRODUCT_AREA.SETTINGS,
            screen_name: ANALYTICS_SCREEN_NAMES.DELETION_CONFIRMATION,
            detail: ANALYTICS_DETAILS.ACKNOWLEDGE_DELETION,
          }}
        />
      }
    >
      <ParagraphText>
        {formatMessage({ id: "STR_ACCOUNT_DELETED_BODY_1" })}
      </ParagraphText>
    </ImageMessageModalContent>
  );
};
